import { INSIGHTS_ENABLED } from './feature_enabled.type'
import ApiRest from '@/api/api-rest'

const state = {
  insightsEnabled: true
}

const getters = {
  insightsEnabled: state => state.insightsEnabled
}

// Best Practice - updates state
const mutations = {
  [INSIGHTS_ENABLED]: (state, resp) => {
    state.insightsEnabled = resp.enabled
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [INSIGHTS_ENABLED]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('/features/enabled/insights')
        .then(({ data }) => {
          if (!data) {
            data = { enabled: true }
          }
          commit(INSIGHTS_ENABLED, data)
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/feature_enabled/feature_enabled.module.js